import { EndpointModel } from "../schema/endpoint.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class EndpointContainer extends MongoBaseContainer{
    endpoint: EndpointModel;
}

